import { Practitioner } from '@luminalearning/types';
import DropdownCard from 'src/Components/MobileComponents/DropdownCard';
import PremiumSubscriptionBody from 'src/Components/Subscription/PremiumSubscriptionBody';

type Props = {
    profile?: Practitioner | null,
    isLoading: Boolean,
};
const SubscriptionCard = (props: Props) => (
    <>
        <div className='invisible mb-4 md:visible mr-6 absolute
                        md:relative md:h-35 bg-white border-1-5 border-card-normal rounded-md'>
            <PremiumSubscriptionBody {...props}/>
        </div>
        <div className='relative md:absolute ml-8 mr-8 md:invisible visible'>
            <DropdownCard
                heading={
                    'Profile & Subscription Details'
                }
                body={
                    <PremiumSubscriptionBody {...props}/>
                }
            />
        </div>
    </>
);

export default SubscriptionCard;